var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.editMode)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.editHtml)}}):_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }